// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleSubmissionUpdateRequestTaskSubmissions } from './moduleSubmissionUpdateRequestTaskSubmissions';
import type { ModuleSubmissionUpdateRequestGrading } from './moduleSubmissionUpdateRequestGrading';

/**
 * Request to update a module submission with task submissions and grading
 */
export interface ModuleSubmissionUpdateRequest {
  taskSubmissions?: ModuleSubmissionUpdateRequestTaskSubmissions;
  grading?: ModuleSubmissionUpdateRequestGrading;
}
